<template>
  <div class="container-fluid">
    <div class="row">
      <div class="title-container w-100 d-flex align-items-center justify-content-between">
        <h3 class="title mr-3">
          Expenses
          <div
            class="spinner-border spinner-theme_default"
            role="status"
            v-if="loading"
          >
              <span class="sr-only">
                Loading...
              </span>
          </div>
        </h3>
        <div class="title-container__controls">
          <b-button
            variant="success"
            v-if="$can('create-finances_expenses_category')"
            type="button"
            class="button"
            @click.prevent="editEntityModalOpen"
            :disabled="loading"
          >
            Create
          </b-button>
        </div>
      </div>

      <b-modal hide-footer ref="FinancesExpensesCategoryModal" >
        <template v-slot:modal-header="{ cancel }">
          <h5 class="modal-title">{{ !!editedItem.id ? 'Edit category' : 'Create category' }} </h5>
          <button
            type="button"
            aria-label="Close"
            class="close"
            @click.prevent="cancel"
          >
          <span class="material-icons">
            close
          </span>
          </button>
        </template>
        <FinancesExpensesCategoryForm
          v-if="dialog"
          :parentCategories="parentCategories"
          :dataProps="editedItem"
          :edit="!!editedItem.id"
          :modal="true"
          :isLoading="loading"
          :show-preloader="true"
          @submit="submit"
        />
      </b-modal>
      <TableForPage
        v-if="table.data.length"
        :isLoading="loading"
        :tableData="table.data"
        :fields="table.fields"
        :slots="table.slots"
        :isEdit="$can('update_all-finances_expenses_category')"
        :isRemove="$can('delete-finances_expenses_category')"
        @edit="editEntityModalOpen"
        @remove="deleteEntity"
      >
        <template slot="parent" slot-scope="data">
          <span>{{ data.item.parent ? data.item.parent.display_name : '' }}</span>
        </template>
      </TableForPage>
      <error-modal ref="errorModal" />
    </div>
  </div>
</template>
<script>
import FinancesExpensesCategoryForm from '../components/forms/FinancesExpensesCategoryForm'
import ErrorModal from '../components/modals/ErrorModal.vue'
import TableForPage from '@tables/TableForPage'

export default {
  name: 'FinancesExpensesCategories',
  data () {
    return {
      loading: true,
      firstLoad: false,
      dialog: false,
      defaultFormData: {},
      editedItem: {
        start_date: ''
      },
      table: {
        slots: {
          parent: {
            name: 'parent'
          }
        },
        fields: [
          {
            key: 'parent',
            label: 'Parent'
          },
          {
            key: 'display_name',
            label: 'Display name'
          },
          {
            key: 'name',
            label: 'Name'
          },
          {
            key: 'is_project_related',
            label: 'Project related',
            formatter: value => {
              return value ? '☑' : '☐'
            }
          },
          {
            key: 'comment',
            label: 'Comment'
          },
          {
            key: 'actions',
            label: 'Actions',
            class: 'column_action'
          }
        ],
        data: []
      },
      parentCategories: []
    }
  },
  components: { ErrorModal, FinancesExpensesCategoryForm, TableForPage },
  created () {
    (async () => {
      if (this.$can('read_own-finances_expenses_category') && !this.$can('read_all-finances_expenses_category')) {
        this.filter.users.push(this._UserInfo)
      }
      await this.getEntities()
    })()
  },
  computed: {},
  methods: {
    getEntities () {
      this.loading = true
      this.axios
        .get('/api/finances/expensesCategory', {
          headers: {
            Authorization: 'Bearer' + localStorage.getItem('access_token')
          }
        })
        .then(response => {
          this.table.data = response.data
          this.parentCategories = this.table.data.filter(cat => cat.parent_id == null)
          this.parentCategories.unshift({ id: '', 'name': 'No parent category' })
        })
        .catch(error => {
          const errors = Object.values(error.response.data.errors)
          for (var i = 0; i < errors.length; i++) {
            this.$snotify.error(
              errors[i][0],
              'Error',
              this.$store.state.snotify
            )
          }
        })
        .finally(() => {
          this.loading = false
          this.firstLoad = true
        })
    },
    create (data) {
      this.loading = true
      this.axios
        .post('/api/finances/expensesCategory', data, {
          headers: {
            Authorization: 'Bearer' + localStorage.getItem('access_token')
          }
        })
        .then(({ data }) => {
          this.$snotify.success(
            'Category successfully created',
            'Success',
            this.$store.state.snotify
          )

          this.dialog = false
          this.getEntities()
          this.editedItem = {}
          this.$refs['FinancesExpensesCategoryModal'].hide()
        })
        .catch(error => {
          const errors = Object.values(error.response.data.errors)
          for (var i = 0; i < errors.length; i++) {
            this.$snotify.error(
              errors[i][0],
              'Error',
              this.$store.state.snotify
            )
          }
        })
        .finally(() => {
          this.loading = false
        })
    },
    editEntityModalOpen (data = {}) {
      this.editedItem = Object.assign({}, data)
      this.dialog = true
      this.$refs['FinancesExpensesCategoryModal'].show()
    },
    edit (data) {
      this.loading = true
      this.axios
        .put('/api/finances/expensesCategory/' + this.editedItem.id, data, {
          headers: {
            Authorization: 'Bearer' + localStorage.getItem('access_token')
          }
        })
        .then(({ data }) => {
          this.$snotify.success(
            'Category successfully saved',
            'Success',
            this.$store.state.snotify
          )

          this.dialog = false
          this.getEntities()
          this.editedItem = {}
          this.$refs['FinancesExpensesCategoryModal'].hide()
        })
        .catch(error => {
          console.log('AAAAA')
          console.log(error.response)

          const errors = Object.values(error.response.data.errors)

          // eslint-disable-next-line no-unused-vars
          for (let [key, value] of Object.entries(errors)) {
            this.$snotify.error(
              value,
              'Error',
              this.$store.state.snotify
            )
          }

          // for (var i = 0; i < errors.length; i++) {
          //     this.$snotify.error(
          //         errors[i][0],
          //         'Error',
          //         this.$store.state.snotify
          //     )
          // }
        })
        .finally(() => {
          this.loading = false
        })
    },
    submit (data) {
      if (this.editedItem.id) {
        this.edit(data)
      } else {
        this.create(data)
      }
    },
    deleteEntity (item) {
      this.loading = true
      this.axios
        .delete(
          '/api/finances/expensesCategory/' + item.id,
          {
            headers: {
              Authorization: 'Bearer' + localStorage.getItem('access_token')
            }
          }
        )
        .then(({ data }) => {
          this.$snotify.success(
            'Category successfully deleted',
            'Success',
            this.$store.state.snotify
          )

          this.getEntities()
        })
        .catch(error => {
          const errors = Object.values(error.response.data.errors)

          // eslint-disable-next-line no-unused-vars
          for (let [key, value] of Object.entries(errors)) {
            if (value instanceof Array) {
              // eslint-disable-next-line no-unused-vars
              for (let [key2, value2] of Object.entries(value)) {
                this.$snotify.error(
                  value2,
                  'Error',
                  this.$store.state.snotify
                )
              }
            } else {
              this.$snotify.error(
                value,
                'Error',
                this.$store.state.snotify
              )
            }
          }
        })
        .finally(() => {
          this.loading = false
        })
    }
  },
  updated () {}
}
</script>

<style scoped>
  .table-wrapper {
    padding-top: 20px;
  }
  .table-wrapper h3 {
    margin-bottom: 30px;
  }
  .entities-table {
    background-color: #fff;
  }
  .entities-table-wrapper {
    max-height: 600px;
    overflow-y: auto;
  }
  .spinner-border {
    border-width: 0.25rem !important;
  }
  .filter-buttons {
    padding-top: 34px;
  }
</style>
